var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageHeader',{attrs:{"title":_vm.title,"subheader":_vm.subheader}}),_c('orders-list',{attrs:{"type":"quotations"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }